const hashString = (str) => {
  if (!str) return 0;
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) ^ str.charCodeAt(i);
  }
  return Math.abs(hash).toString(16);
};

const extractFilenames = (urls) => {
  if (!Array.isArray(urls)) return [];
  return urls.map(url => {
    try {
      const pathname = new URL(url).pathname;
      return pathname.split('/').pop().split('?')[0];
    } catch {
      return '';
    }
  }).filter(Boolean);
};

const getSnapshotKey = (accountId, asin) => `media_snapshot_v1_${accountId}_${asin}`;

const saveSnapshot = (accountId, asin, mediaObj) => {
  const key = getSnapshotKey(accountId, asin);
  const existing = localStorage.getItem(key);
  const isFirstSave = !existing;

  const snapshot = {
    asin,
    snapshotAt: new Date().toISOString(),
    infographicsCount: Array.isArray(mediaObj.infographics) ? mediaObj.infographics.length : 0,
    infographicsFilenames: extractFilenames(mediaObj.infographics || []),
    ugcVideosCount: Array.isArray(mediaObj.ugc_videos) ? mediaObj.ugc_videos.length : 0,
    ugcVideosHash: hashString((mediaObj.ugc_videos || []).map(v => v.url || v.title || '').sort().join('|')),
    aplusModulesCount: Array.isArray(mediaObj.aplus_content) ? mediaObj.aplus_content.length : 0,
    aplusContentHash: hashString(JSON.stringify(mediaObj.aplus_content || [])),
    bulletPointsCount: Array.isArray(mediaObj.bullet_points) ? mediaObj.bullet_points.length : 0,
    bulletPointsHash: hashString((mediaObj.bullet_points || []).join(' ')),
    descriptionHash: hashString((mediaObj.description || '').trim()),
  };

  try {
    localStorage.setItem(key, JSON.stringify(snapshot));
  } catch (e) {
    console.warn(`Failed to save media snapshot for ${asin}:`, e);
  }

  return { isFirstSave };
};

const loadSnapshot = (accountId, asin) => {
  const key = getSnapshotKey(accountId, asin);
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    console.warn(`Failed to load media snapshot for ${asin}:`, e);
    return null;
  }
};

const clearSnapshot = (accountId, asin) => {
  const key = getSnapshotKey(accountId, asin);
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.warn(`Failed to clear media snapshot for ${asin}:`, e);
  }
};

const loadAllSnapshots = (accountId, asins) => {
  const result = new Map();
  asins.forEach(asin => {
    const snapshot = loadSnapshot(accountId, asin);
    if (snapshot) {
      result.set(asin, snapshot);
    }
  });
  return result;
};

export { saveSnapshot, loadSnapshot, clearSnapshot, loadAllSnapshots, hashString };
